import React from "react";

import "./styles.css";

const Thead = (props) => {
  return <thead className="t-head">{props.children}</thead>;
};

export default Thead;
